import { render, staticRenderFns } from "./ExpandedCollectionPage.vue?vue&type=template&id=49439b58"
import script from "./ExpandedCollectionPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpandedCollectionPage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports